<template>
<div v-if="notifications">
    <h2 class="text_center no-bottom-margin">Notifications</h2>
    <hr>
    <div class="custom-jumbotron container-fluid less-top-padding less-bottom-padding">
        <div class="row">
            <div class="align-left" v-for="notification in notifications" :key="notification.userMessageId">
                <div v-if="notification.type == 'GLOBAL'">
                    <pre>
                        {{ notification.message }}
                    </pre>
                </div>
            </div>
        </div>
          <hr v-if="notifications?.filter((item) => item.type == 'GLOBAL').length > 0">
        <div class="row">
            <div v-if="notifications?.filter((item) => item.type == 'APPROVAL').length > 0" class="black">
                <b>
                    User(s) Pending Approval:
                    <br>
                    <br>
                    <ul style="  padding: 0;list-style-type: none;">
                        <div v-for="notification in notifications" :key="notification.userMessageId">
                            <li v-if="notification.type == 'APPROVAL'"><pre>{{ notification.message }}</pre></li>
                        </div>
                    </ul>
                </b>
            </div>
            <hr v-if="notifications?.filter((item) => item.type == 'APPROVAL').length > 0">
            <div v-if="notifications?.filter((item) => item.type == 'SIGNATURE').length > 0" class="black">
                <b>
                    Order(s) Pending Signature:
                    <br>
                    <br>
                    <ul style="  padding: 0;list-style-type: none;">
                        <div v-for="notification in notifications" :key="notification.userMessageId">
                            <li v-if="notification.type == 'SIGNATURE'"><pre class="pre">{{ notification.message }}</pre></li>
                        </div>
                    </ul>
                </b>
            </div>
           <!-- <div class="col-md-4 text-left black">
                Not implemented future notifications 2:
            </div> -->
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";

export default {
    name: "NotificationBox",
    data() {
        return {}
    },
    created() {

    },
    mounted() {
        this.getNotifications()
    },
    computed: {
        ...mapGetters({
            notifications: 'notifications/notifications',
        })
    },
    methods: {
        ...mapActions({
            getNotifications: 'notifications/getNotifications',
            setNotificationsAlreadyShown: 'notifications/setNotificationsAlreadyShown'
        }),
    }
}
</script>

<style scoped>
.custom-jumbotron {
    /* background-color: #c4e3f2; */
    border-radius: 15px;
}
.pre {
    width: inherit;
    white-space: pre-wrap;
    font-family: "Poppins", sans-serif;
}
</style>
